/**
 * The Spraywall wall document's client-written shapes — what the wall editor's
 * "Létrehozás" writes (`SprayWallEditor.createWall`) and what placing the wall
 * on the map writes (`sprayWallPlacementPatch`, utils/sprayWallMap.js). Pure,
 * so the E2E seed (tests/e2e/seed/spraywall.js) builds its fixture walls
 * through the same functions instead of a second copy of the shape.
 *
 * The keys are exactly the client-writable wall keys of `firestore.rules`
 * (`sprayWallClientKeys()`). Everything else on the wall — `currentVersionId`,
 * `photo`, `outline`, `deleting` — is written by the version and cascade
 * callables, never by a client.
 *
 * `timestamp` is the value of `createdAt` / `updatedAt`: the client passes
 * `serverTimestamp()` of the web SDK, the seed the Admin SDK's
 * `FieldValue.serverTimestamp()` (a sentinel cannot be made without one of
 * the two SDKs, and this module imports neither).
 */

/**
 * @param {object} p
 * @param {string} p.name                    1–60 characters, already trimmed
 * @param {string} [p.description]           ≤ 500 characters, already trimmed
 * @param {number|null} [p.angle]            the wall's overhang in degrees, or null
 * @param {number} p.order                   the wall's place in the picker
 * @param {boolean} p.active                 shown to members once published
 * @param {boolean|null} [p.membersCanCreate] null = the gym's default
 * @param {string} p.uid                     the writer (`lastModifiedBy`)
 * @param {*} p.timestamp                    the server-timestamp sentinel
 */
export function buildNewSprayWallDoc({ name, description, angle, order, active, membersCanCreate, uid, timestamp }) {
  return {
    name,
    description: description || "",
    angle: Number.isFinite(angle) ? angle : null,
    order,
    active: active === true,
    membersCanCreate: typeof membersCanCreate === "boolean" ? membersCanCreate : null,
    createdAt: timestamp,
    updatedAt: timestamp,
    lastModifiedBy: uid,
  };
}

/**
 * The fields of placing (or moving) a wall on a gym map. `x` / `y` are in the
 * map image's pixel coordinates, like a route's.
 */
export function buildSprayWallPlacement({ mapId, x, y, uid, timestamp }) {
  return { mapId, x, y, updatedAt: timestamp, lastModifiedBy: uid };
}
